/**
 * `inboxEntryIds` is a DynamoDB String Set — unordered, so "most recently
 * linked" is not recoverable from it. Sorting gives web and api the same
 * answer for the same message; when the caller knows which DoBox the user is
 * in (a route param, a board), that entry wins over this fallback.
 */
export const getPrimaryInboxEntryId = (
  inboxEntryIds?: string[] | Set<string>,
): string | undefined => [...(inboxEntryIds ?? [])].sort()[0];
